// import Login from "../pages/Authentication/Login"
// import Register from "../pages/Authentication/Register"
// import Redirection from "../pages/Authentication/Redirection"
// import DetailIns from "../pages/Authentication/DetailIns"
// import CheckIns from "../pages/Authentication/CheckIns"
// import EditIns from "../pages/Authentication/EditIns"
// import Score from "../pages/Authentication/Score"
// const publicRoutes = [
//   { path: "/login", component: Login },
//   { path: "/register", component: Register },
//   { path: "/Redirection", component: Redirection },
//   { path: "/Score", component: Score },
//   { path: "/DetailIns", component: DetailIns },
//   { path: "/CheckIns", component: CheckIns },
//   { path: "/EditIns", component: EditIns },
// ]
// export { publicRoutes }


import Login from "../pages/Authentication/Login";
import Register from "../pages/Authentication/Register";
import Redirection from "../pages/Authentication/Redirection";
import DetailIns from "../pages/Authentication/DetailIns";
import CheckIns from "../pages/Authentication/CheckIns";
import EditIns from "../pages/Authentication/EditIns";
import Score from "../pages/Authentication/Score";
import Login1 from "../pages/Authentication/Login1"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import ResetPassword from "../pages/Authentication/ResetPassword"
const publicRoutes = [
  { path: "/login1", component: Login1 },
  { path: "/login", component: Login },
  { path: "/Redirection", component: Redirection },
  { path: "/Score", component: Score },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/ResetPassword/:token", component: ResetPassword },
]

const masterOpenRoutes = [
  { path: "/register", component: Register },
  { path: "/DetailIns", component: DetailIns },
  { path: "/CheckIns", component: CheckIns },
  { path: "/EditIns", component: EditIns },
];

export { publicRoutes, masterOpenRoutes };


// import React from "react";
// import ReactDOM from "react-dom";
// import { BrowserRouter } from "react-router-dom";
// import App from "../App";
// import { MasterProvider } from "./MasterContext";
//
// ReactDOM.render(
//   <BrowserRouter>
//     <MasterProvider>
//       <App />
//     </MasterProvider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );
